<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_x"></a><a id="page_xi">Contents</a></p><a id="page_xi">
</a><p class="TocSb1" id="pre"><a id="page_xi"></a><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001"><span class="small">ONE</span></a></p>
<p class="Toc1"><a href="#/xhtml/chapter001#ch001">My People</a></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample"><span class="small">TWO</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">Vistas</span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample"><span class="small">THREE</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">Yale</span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample"><span class="small">FOUR</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">Teaching in Turbulent Times</span></p>
<p class="Toc" id="ch-005"><a id="page_xii"></a><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample"><span class="small">FIVE</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">Beyond Teaching</span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample"><span class="small">SIX</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">Awakenings</span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample"><span class="small">SEVEN</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">Living with Grief</span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample"><span class="small">EIGHT</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">Amsterdam, Church, Garden</span></p>
<p class="Toc" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample"><span class="small">NINE</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">Return to Yale</span></p>
<p class="Toc" id="ch-010"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample"><span class="small">TEN</span></span></p>
<p class="Toc1"><span href="#/xhtml/chapter010#ch010" title="Link target outside of Sample">Still Vistas</span></p>
<p class="Toc" id="epi"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample"><span class="small">EPILOGUE</span></span></p>
<p class="Toc1"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Grace and Gratitude</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?94fd5580